import * as XLSX from 'xlsx'

function fmtDate (val) {
  if (!val) return ''
  if (val instanceof Date) return val.toISOString().split('T')[0]
  return String(val).trim()
}

function str (val) {
  if (val === null || val === undefined) return ''
  return String(val).trim()
}

function parseShareholder (row, n) {
  const p = `Shareholder ${n}`
  const name = str(row[`${p}: Name (as per identity document)`])
  if (!name) return null

  const sh = {
    role: 'shareholder',
    sort_order: n,
    full_name: name,
    gender: str(row[`${p}: Gender `]),
    nationality: str(row[`${p}: Nationality `]),
    nric_number: str(row[`${p}: NRIC Number`]),
    race: str(row[`${p}: Race `]),
    passport_number: str(row[`${p}: Passport Number`]),
    passport_expiry: fmtDate(row[`${p}: Passport Expiry Date`]),
    residential_address: str(row[`${p}: Residential Address`]),
    phone: str(row[`${p}: Phone Number`]),
    email: str(row[`${p}: Email Address`]),
    is_also_director: str(row[`${p}: Is he or she also a director to the proposed company? `]),
    shares_held: str(row[`${p}: Number of Shares Held (Unit)`]),
    source_of_funds: str(row[`${p}: Source of fund to invest into the proposed company `]),
    // corporate entity fields present only for SH 1-3
    corp_registered_name: '',
    corp_place_of_registration: '',
    corp_registration_body: '',
    corp_registration_number: '',
    corp_registered_address: '',
    corp_controlled_by: '',
    corp_phone: '',
    corp_email: '',
    corp_shares_held: '',
    corp_rep_name: '',
    corp_rep_nric_passport: ''
  }

  if (n <= 3) {
    sh.corp_registered_name = str(row[`${p}: Registered Name`])
    sh.corp_place_of_registration = str(row[`${p}: Place of Registration `])
    sh.corp_registration_body = str(row[`${p}: Registration Body `])
    sh.corp_registration_number = str(row[`${p}: Registration Number`])
    sh.corp_registered_address = str(row[`${p}: Registered Address`])
    sh.corp_controlled_by = str(row[`${p}: The entity is controlled by who? `])
    sh.corp_phone = str(row[`${p}: Phone Number${n === 1 ? '2' : n === 2 ? '5' : '8'}`])
    sh.corp_email = str(row[`${p}: Email Address${n === 1 ? '3' : n === 2 ? '6' : '9'}`])
    sh.corp_shares_held = str(row[`${p}: Number of Shares Held (Unit)${n === 1 ? '4' : n === 2 ? '7' : '10'}`])
    sh.corp_rep_name = str(row[`${p}: Corporate Representative - Name (as per identity document)`])
    sh.corp_rep_nric_passport = str(row[`${p}: Corporate Representative - NRIC Number / Passport Number`])
  }

  return sh
}

function parseDirector (row, n) {
  const p = `Director ${n}`
  const name = str(row[`${p}: Name (as per identity document)`])
  if (!name) return null
  return {
    role: 'director',
    sort_order: n,
    full_name: name,
    gender: str(row[`${p}: Gender `]),
    nationality: str(row[`${p}: Nationality `]),
    nric_number: str(row[`${p}: NRIC Number`]),
    race: str(row[`${p}: Race `]),
    passport_number: str(row[`${p}: Passport Number`]),
    passport_expiry: fmtDate(row[`${p}: Passport Expiry Date`]),
    residential_address: str(row[`${p}: Residential Address`]),
    phone: str(row[`${p}: Phone Number`]),
    email: str(row[`${p}: Email Address`])
  }
}

function parseNextOfKin (row) {
  const name = str(row['Sole Director: Next of Kin - Name'])
  if (!name) return null
  return {
    role: 'next_of_kin',
    sort_order: 1,
    full_name: name,
    nric_number: str(row['Sole Director: Next of Kin - NRIC No.']),
    residential_address: str(row['Sole Director: Next of Kin - Residential Address']),
    phone: str(row['Sole Director: Next of Kin - Phone No.']),
    email: str(row['Sole Director: Next of Kin - Email Address']),
    relationship: str(row['Sole Director: Next of Kin - Relationship '])
  }
}

export function parseCosecXlsx (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result)
        const wb = XLSX.read(data, { type: 'array', cellDates: true })
        const ws = wb.Sheets[wb.SheetNames[0]]
        const rows = XLSX.utils.sheet_to_json(ws, { defval: '' })

        const companies = rows
          .map((row, idx) => {
            const company = {
              _rowIndex: idx,
              client: str(row['Proposed Company Name']),
              company_name_explanation: str(row['Explanation of Proposed Company Name']),
              nature_of_business: str(row['Nature of Business']),
              business_address: str(row['Business Address']),
              records_at_business_address: str(row['Will you keep all financial records such as invoice, receipts and accounts at business address? ']),
              records_address: str(row['Address where financial records will be kept']),
              business_phone: str(row['Business Phone Number']),
              business_email: str(row['Business Email Address']),
              initial_capital: str(row['Initial Paid-Up Capital (RM) ']),
              price_per_share: str(row['Price Per Share (RM) ']),
              total_shares: str(row['Total Number of Shares (Unit) ']),
              year_end: str(row["Preferred Company's Year End"]),
              persons: []
            }

            for (let n = 1; n <= 6; n++) {
              const sh = parseShareholder(row, n)
              if (sh) company.persons.push(sh)
            }
            for (let n = 1; n <= 3; n++) {
              const dir = parseDirector(row, n)
              if (dir) company.persons.push(dir)
            }
            const nok = parseNextOfKin(row)
            if (nok) company.persons.push(nok)

            return company
          })
          .filter(c => c.client)

        resolve(companies)
      } catch (err) {
        reject(err)
      }
    }
    reader.onerror = () => reject(new Error('Failed to read file'))
    reader.readAsArrayBuffer(file)
  })
}
